import {ModalProps} from "react-bootstrap/Modal";
import {Modal} from "react-bootstrap";
import React, {FC, memo, useCallback, useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {AppDispatch} from "../../store/configureStore";
import {fetchVideoToken} from "../../fetch/RequestVideo";
import {actions, ICameraAll} from "../../store/sliceModal";
import WebSocketCamera from "../../component/WebCamSocket/WebSocketCamera";
import {actions as websocket} from "../../store/sliceWebsocket";

const ModalCameraAll: FC<ModalProps> = (props) => {
    const {show, onHide } = props
    const { title, name } = props.camera
    const dispatch = useDispatch<AppDispatch>();

    const [token, setToken] = useState<boolean>(false);

    const [camFailArray, setCamFailArray] = useState<Array<string>>([]);

    useEffect(() => {
        if (show) {
            fetchVideoToken().then(response => {
                if (response.status == 204) {
                    setToken(true)
                } else {
                    dispatch(actions.showError("Доступ запрещен"))
                }
            })
            setCamFailArray([]);
        }
    }, [show])

    const init = useCallback((cameraNme: string) => {
        if (show) {

                dispatch(websocket.send({body: "", topic: `/app/cam/${cameraNme}`}))
            // dispatch(websocket.send({body: "", topic: `/app/cam`}))
        }
    }, [show])

    const close = useCallback((cameraNme: string) => {
        if (show) {
            const camArray = camFailArray;
            camArray.push(cameraNme);
           setCamFailArray(camArray);
        }
    }, [show, camFailArray])

    return (
        <Modal
            {...props}
            fullscreen={true}
            centered
        >
            <Modal.Header closeButton style={{gap: "10px"}}>{title}</Modal.Header>
            <Modal.Body>
                <div style={{display: "flex", justifyContent: "center"}}>
                <div style={{display: "flex", flexDirection: "column", gap: "10px", maxWidth: "600px"}}>
                    {Array.isArray(name) && name.map((cam) => {
                        return !camFailArray.includes(cam) && <WebSocketCamera init={() => init(cam)} name={cam} sound={false} onHide={() => close(cam)} isClose={false}/>
                    })
                    }
                </div>
                </div>


            </Modal.Body>
        </Modal>
    )
        ;
}

export default memo(ModalCameraAll)
